import { get, push, ref, update } from "firebase/database";
import { database } from "../../../Utils/firebase";

const AddItemDataInFirebase = async (state, dispatch, itemData, userId, islocal) => {
  const USERID = userId ? userId : state?.USERID;
  console.log("userid", USERID);
  if (!USERID) return null;

  try {
    const currentBusiness = state?.BUSINESSES?.find(b => String(b.companyId) === String(state?.SELECTEDBUSINESS));
    const isShared = currentBusiness?.isShared === true;

    const actorName = state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest";
    const auditTrail = isShared ? {
      createdBy: actorName,
      createdById: state?.USERID || null,
      updatedBy: actorName,
      updatedById: state?.USERID || null,
    } : {};

    const updateAuditTrail = isShared ? {
      updatedBy: actorName,
      updatedById: state?.USERID || null,
    } : {};

    const itemsRef = ref(database, `invoiceGenerator/users/${USERID}/items`);

    if (!Array.isArray(itemData)) return;

    if (!islocal) {
      // 🔍 Non-local data: check and update or push
      const snapshot = await get(itemsRef);
      const existingItems = snapshot.val() || {};
      const existingItemsArray = Object.entries(existingItems); // [ [key, value], ... ]

      for (let newItem of itemData) {
        let matchedItem = null;
        let matchedKey = null;

        for (let [key, existingItem] of existingItemsArray) {
          if (
            existingItem.name?.toLowerCase() === newItem.name?.toLowerCase()
          ) {
            matchedItem = existingItem;
            matchedKey = key;
            break;
          }
        }

        if (matchedItem && matchedKey) {
          const itemUpdateRef = ref(database, `invoiceGenerator/users/${USERID}/items/${matchedKey}`);
          await update(itemUpdateRef, {
            ...updateAuditTrail,
            ...matchedItem,
            defaultPrice: newItem.price?.toString(),
            subtitle: newItem.subtitle?.toString() || "",
            updatedDate: Date.now().toString(),
          });
        } else {
          const cleanedItem = {
            ...auditTrail,
            itemId: newItem.itemId?.toString() || Date.now().toString(),
            name: newItem?.name?.toString() || "",
            defaultPrice: newItem.price?.toString() || "0.00",
            purchasePrice: "0.00",
            subtitle: newItem.subtitle?.toString() || "",
            createdDate: Date.now().toString(),
            updatedDate: Date.now().toString(),
          };
          await push(itemsRef, cleanedItem);
        }
      }
    } else {
      // 📦 Local data: add all items directly
      for (let newItem of itemData) {
        const cleanedItem = {
          ...auditTrail,
          itemId: newItem.itemId?.toString() || Date.now().toString(),
          name: newItem?.name?.toString() || "",
          defaultPrice: newItem.price?.toString() || "0.00",
          purchasePrice: "0.00",
          subtitle: newItem.subtitle?.toString() || "",
          createdDate: Date.now().toString(),
          updatedDate: Date.now().toString(),
        };
        await push(itemsRef, cleanedItem);
      }
    }

  } catch (error) {
    console.error("Error adding item to Firebase REAL USER:", error);
    return null;
  }
};

export default AddItemDataInFirebase;
